<template>
  <div class="atto-select search-filtering">
    <div
      class="select-heading"
      @click="toggle"
    >
      <span :class="{selected: option}">{{ getLabel(option) }}</span>
      <i class="atto atto-d-arrow-b" />
    </div>
    <div
      v-if="opened"
      class="select-options"
      :class="{opened: opened}"
    >
      <div
        class="heading"
      >
        <!--                <span :class="{selected: option}">{{ getLabel(option) }}</span>-->
        <div class="search-wrapper">
          <input
            ref="search"
            v-model="input"
            type="text"
            class="search-input"
            :placeholder="placeholder"
            @input="onInputChange"
          >
          <i class="atto atto-search-loop" />
        </div>
      </div>
      <div
        v-show="options.length > 0 || searching"
        class="options"
      >
        <perfect-scrollbar>
          <ul v-if="searching || (options.length === 0 && !searching)">
            <li
              v-if="searching"
              class="no-options"
            >
              {{label.get('searching')}}
            </li>
            <li
              v-if="options.length === 0 && !searching"
              class="no-results"
            >
              {{ label.get('no_results_found') }}
            </li>
          </ul>
          <ul v-if="!searching">
            <li
              v-for="(o, idx) in options"

              :key="idx"
              @click="onOptionSelected(o)"
            >
              {{ o.label }}
            </li>
          </ul>
        </perfect-scrollbar>
      </div>
    </div>
    <div
      v-if="opened"
      class="select_overlay"
      @click="toggle"
    />
  </div>
</template>

<script>
    export default {
        name: "SearchDropdownComponent",
        props: {
            placeholder: {
                type: String,
                default: '',
                required: false
            },
            options: {
                type: Array,
                required: true
            },
            value: {
                type: Number | null,
                default: null
            },
            index: {
                type: Number | null,
                default: null
            },
            emptyOptionsHint: {
                type: String | undefined,
                default: undefined
            }
        },
        data() {
            return {
                opened: false,
                option: this.selectOption(),
                input: null,
                searching: false
            }
        },

        watch: {
            value: function (newVal, oldVal) {
                if (newVal == null) {
                    this.option = null;
                } else {
                    let opt = this.options.filter(item => {
                        if(newVal instanceof Object) {
                          return item.value === newVal.value;
                        } else {
                          return item.value === newVal;
                        }
                    });
                    if (opt.length > 0) {
                        this.option = opt[0];
                    } else {
                      this.option = newVal;
                    }
                }
            },
            options: function (newList, oldList) {
                this.searching = false;
            }
        },
        methods: {
            getLabel(opt) {
                if (opt != null) {
                    return opt.label;
                }
                return this.placeholder;
            },
            selectOption() {
                let opt = this.options.filter(item => {
                    return item.value === this.value;
                });
                if (opt.length > 0) {
                    return opt[0];
                }
                if (this.value instanceof Object) {
                    return this.value;
                }
                return null;
            },
            onOptionSelected(opt) {
                this.option = opt;
                this.$emit('onOptionSelected', this.option, this.index);
                this.opened = false;
                this.input = null;
            },
            onInputChange() {
                this.$emit('onInputChange', this.input, this.index);
                this.searching = this.input !== '' && this.input !== null;
            },
            toggle() {
                const _this = this;
                _this.opened = !_this.opened;
                _this.$nextTick(() => {
                  if(_this.$refs.search !== undefined) {
                    _this.$refs.search.focus();
                  }
                });

            }
        }
    }
</script>

<style lang="scss" scoped>
    .atto-select {
        display: flex;
        width: auto;
        height: 40px;
        position: relative;
        cursor: pointer;

        .select-heading {
            padding: 8px 6px 8px 10px;
            border: 2px solid #efefef;
            display: flex;
            align-items: center;

            span {
                display: inline-flex;
                min-width: calc(100% - 24px);
                max-width: calc(100% - 24px);
                font-size: 0.875rem;
                line-height: 1.5rem;
                font-family: $roboto-font;
                font-weight: $roboto-regular;
                color: $atto-not-active;

                &.selected {
                    color: $atto-font-color;
                }
            }

            i {
                display: inline-flex;
                width: 24px;
                height: 24px;
                align-items: center;
                justify-content: center;
                font-size: 13px;
                margin-left: auto;
                color: #c7c7c7;
            }
        }

        .select-options {
            position: absolute;
            top: -8px;
            left: 0;
            box-shadow: 0 0 8px 0 rgba(38, 38, 38, 0.15);
            background-color: #fff;
            width: 100%;
            z-index: 1001;

            .heading {
                border-bottom: 2px solid $atto-light-grey;
                display: flex;
                flex-direction: row;
                padding: 16px 8px 16px 12px;

                span {
                    display: inline-flex;
                    font-size: 0.875rem;
                    line-height: 1.5rem;
                    font-family: $roboto-font;
                    font-weight: 500;
                    color: $atto-not-active;
                    flex-grow: 1;

                    &.selected {
                        color: $atto-font-color;
                    }
                }

                i {
                    display: inline-flex;
                    width: 24px;
                    height: 24px;
                    margin-right: 0px;
                    margin-left: auto;
                    font-size: 13px;
                    align-items: center;
                    justify-content: center;
                    color: #c7c7c7;
                }

                .search-wrapper {
                    width: 100%;
                    display: flex;
                    flex-direction: row;

                    input {
                        border: 0!important;
                        box-shadow: none;
                        outline: 0;
                        font-size: 0.875rem;
                        line-height: 1.5rem;
                        font-family: $roboto-font;
                        font-weight: 500;
                        color: $atto-font-color;
                        display: inline-flex;
                        flex-grow: 1;
                        width: calc(100% - 32px);
                        margin-right: 8px;
                        padding: 0!important;

                        @include style-placeholder($atto-not-active);

                        /*&:focus{
                            border-bottom: 2px solid $atto-teal;
                        }*/
                    }

                    i {
                        width: 24px;
                        height: 24px;
                    }
                }
            }

            .options {
                padding: 8px 0;

                .ps {
                    max-height: 240px;
                }

                ul {
                    li {
                        padding: 8px 12px;
                        font-size: 0.875rem;
                        line-height: 1.5rem;
                        font-family: $roboto-font;
                        font-weight: $roboto-medium;
                        color: $atto-font-color;
                        cursor: pointer;
                        @include base-transition(ease all 0.15s);

                        &:hover {
                            background-color: #F7F7F7;
                        }
                    }
                }
            }

            &.opened {
                &::after {
                    content: "";
                    width: 100%;
                    height: 20px;
                    position: absolute;
                    bottom: -20px;
                    left: 0;
                }
            }
        }

        &.opened {
            .select-options {
                display: block;
            }
        }

        .select_overlay {
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            z-index: 1000;
        }

        > .ps {
            max-height: 256px;
            overflow: visible !important;

            &.ps--active-y {
                .select-options {
                    margin-bottom: 50px;
                }
            }
        }

        &.search-filtering {
            /*min-width: 210px;*/
            /*width: 100%;*/
            width: auto;
        }
    }
</style>